import {appConfig} from '@/config/appConfig';
import {debug} from '@/shared/helpers/debug';
import {App} from '@capacitor/app';
import type {Plugin} from 'vue';
import {useRouter} from 'vue-router';

/**
 * Configures handling of hybrid app specific global functionality:
 * - Handling of MSAL authentication redirects
 */
export const hybridAppPlugin = {
    install(app) {
        if (!appConfig.isHybridApp) {
            return;
        }
        app.runWithContext(() => {
            const router = useRouter();

            App.addListener('appUrlOpen', async data => {
                debug.log('App opened with URL:', data.url);

                // Check if it's an MSAL authentication redirect
                // Format: msauth.[bundle-id]://auth#code=...
                if (data.url.startsWith('msauth.')) {
                    return handleMsalRedirect(data.url);
                }
            });

            function handleMsalRedirect(url: string) {
                debug.log('MSAL redirect URL detected:', url);

                const code = url.split('#')[1];
                debug.log('Extracted code from URL:', code);

                router.push({name: 'Home', hash: '#' + code});
            }
        });
    },
} satisfies Plugin;
